import React, { Suspense } from 'react';

import WebSubscriptionPlanChooser from 'components/SubscriptionPlanChooser/WebSubscriptionPlanChooser';
import { isApp } from 'services/environment';

const AppSubscriptionPlanChooser = React.lazy(() =>
  import(/* webpackChunkName: 'app-subscription-plan-chooser' */ 'components/SubscriptionPlanChooser/AppSubscriptionPlanChooser'),
);

function SubscriptionPlanChooser(props) {
  if (isApp()) {
    return (
      <Suspense fallback={null}>
        <AppSubscriptionPlanChooser {...props} />
      </Suspense>
    );
  }
  return <WebSubscriptionPlanChooser {...props} />;
}

export default SubscriptionPlanChooser;
